import React from 'react'
import { useField} from 'formik';
const Switch = ({ label, ...props }) => {
    const [field, , helpers] = useField(props);
    const { value } = field;
    const { setValue } = helpers;
    const handleToggle = () => {
        setValue(!value); 
    };
    return (
        <div className={`${label && 'mb-3'} d-flex align-items-center`}>
            <label className="custom-switch">
                <input
                    type="checkbox"
                    checked={value}
                    onChange={handleToggle}
                />
                <span className="slider" />
            </label>
            {label && <span className="switch-label">{value ? 'On' : 'Off'}</span>}
        </div>
    )
}

export default Switch